module.exports = __webpack_public_path__ + "static/img/ys68.b03a0b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ys68.png
// module id = 7lIZ
// module chunks = 73